<template>
  <div class="header">
    <div class="max-width row-block" v-if="isLogin">
      <div class="left row-block">
        <router-link class="logo row-block" :to="{ name: !isLogin ? 'main' : 'tutorial' }">
          <img :src="require('../../assets/images/main-logo.png')" alt="">
          <span>農產業貿易潛力分析平台</span>
        </router-link>
        <div class="tab-container row-block">
          <div v-for="([value, data], index) in Object.entries(categorys).filter(([key, value]) => (value.display || (() => true))())" :key="index">
            <router-link v-if="data.to" :to="data.to">
              <div class="user-col">
                <button class="menu-button" :class="{ selected: value === $route.name }">
                  <div class="main-field">
                    <div class="title">
                      <span>{{ data.name }}</span>
                    </div>
                  </div>
                </button>
              </div>
            </router-link>
            <borCor
              v-else-if="data.lists"
              :type="'bottom'"
              :width="data.width"
              :cursorStyle="{ width: '100px' }"
            >
              <div slot="trigger">
                <div class="user-col">
                  <button class="menu-button" :class="{ selected: data.lists.some(list => list.value === $route.name) }">
                    <div class="main-field">
                      <div class="title">
                        <span>{{ data.name }}</span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
              <div slot="content">
                <router-link v-for="(list, lindex) in data.lists.filter(list => (list.display || (() => true))())" :key="lindex" :to="list.to">
                  <div class="list-button row-block" :class="{ selected: list.value === $route.name }">
                    <div class="list-block">{{ list.name }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </router-link>
              </div>
            </borCor>
          </div>
        </div>
      </div>
      <div class="center">
      </div>
      <div class="right row-block">
        <router-link :to="{ name: 'user' }">
          <div class="user row-block">
            <img :src="require('../../assets/images/avatar.png')">
            <div :style="{ width: '10px' }"></div>
            <span>{{ user.name }}</span>
          </div>
        </router-link>
        <div :style="{ width: '36px' }"></div>
        <div class="logout row-block">
          <button type="button" name="button" class="main-button" @click="e => logoutClick()">
            <span>登出</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { deleteUser } from '../../api'
import borCor from '../../components/tool/borCor'
import toastMethods from '../../mixins/toastMethods'
import responsitive from '../../mixins/responsitive'
import loginData from '../../mixins/loginData'

export default {
  components: {
    borCor
  },
  mixins: [
    toastMethods,
    responsitive,
    loginData
  ],
  computed: {
    ...mapGetters([
      'isLogin',
      'user',
      'normalPage'
    ]),
    // static data
    categorys () {
      return {
        product: {
          name: '農產品分析',
          width: '115px',
          lists: [
            {
              name: '市場吸引力',
              value: 'attraction',
              to: { name: 'attraction' }
            },
            {
              name: '市場競爭力',
              value: 'competitiveness',
              to: { name: 'competitiveness' }
            },
            {
              name: '零售價格分析',
              value: 'productPrice',
              to: { name: 'productPrice' }
            }
          ]
        },
        tool: {
          name: '農業機械分析',
          width: '115px',
          lists: [
            {
              name: '市場吸引力',
              value: 'toolattraction',
              to: { name: 'toolattraction' }
            },
            {
              name: '市場競爭力',
              value: 'toolcompetitiveness',
              to: { name: 'toolcompetitiveness' }
            }
          ]
        },
        report: {
          name: '分析報告',
          to: { name: 'report' }
        },
        tutorial: {
          name: '介紹與教學',
          to: { name: 'tutorial' }
        },
        admin: {
          name: '管理者專區',
          width: '142px',
          lists: [
            {
              name: '會員帳號管理',
              value: 'admin',
              to: { name: 'admin' }
            },
            {
              name: '零售價格資料管理',
              value: 'adminProductPrice',
              to: { name: 'adminProductPrice' }
            },
            {
              name: '分析報告管理',
              value: 'adminReport',
              to: { name: 'adminReport' }
            },
            {
              name: '會員操作記錄',
              value: 'adminAccessLog',
              to: { name: 'adminAccessLog' }
            }
          ],
          display: () => this.user.role === 'admin'
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'setModalAction'
    ]),
    async logoutClick () {
      try {
        let config = this.$ls.get('userInfo')
        await deleteUser(config)
        this.setUserData(null)
        this.$router.push({ name: 'main' })
        this.addToast('success', '登出成功')
      } catch (error) {
        this.setLoginAction(true)
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/header.vue